import { render, staticRenderFns } from "./AuditLog.vue?vue&type=template&id=3c4f78a6&scoped=true"
import script from "./AuditLog.vue?vue&type=script&lang=js"
export * from "./AuditLog.vue?vue&type=script&lang=js"
import style0 from "./AuditLog.vue?vue&type=style&index=0&id=3c4f78a6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4f78a6",
  null
  
)

export default component.exports